import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component } from '@wordpress/element';
import { Button } from '@wordpress/components';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
/**
 * WooCommerce dependencies
 */

import { getIdsFromQuery, updateQueryString } from '@woocommerce/navigation';
/**
 * Internal dependencies
 */

import Card from '../card';
import CompareButton from './button';
import Search from '../search';
export { default as CompareButton } from './button';
/**
 * Displays a card + search used to filter results as a comparison between objects.
 */

export var CompareFilter =
/*#__PURE__*/
function (_Component) {
  _inherits(CompareFilter, _Component);

  function CompareFilter(_ref) {
    var _this;

    var getLabels = _ref.getLabels,
        param = _ref.param,
        query = _ref.query;

    _classCallCheck(this, CompareFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompareFilter).apply(this, arguments));
    _this.state = {
      selected: []
    };
    _this.clearQuery = _this.clearQuery.bind(_assertThisInitialized(_this));
    _this.updateQuery = _this.updateQuery.bind(_assertThisInitialized(_this));
    _this.updateLabels = _this.updateLabels.bind(_assertThisInitialized(_this));

    if (query[param]) {
      getLabels(query[param], query).then(_this.updateLabels);
    }

    return _this;
  }

  _createClass(CompareFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2, _ref3) {
      var prevParam = _ref2.param,
          prevQuery = _ref2.query;
      var prevSelected = _ref3.selected;
      var _this$props = this.props,
          getLabels = _this$props.getLabels,
          param = _this$props.param,
          query = _this$props.query;
      var selected = this.state.selected;

      if (prevParam !== param || prevSelected.length > 0 && selected.length === 0) {
        this.clearQuery();
        return;
      }

      var prevIds = getIdsFromQuery(prevQuery[param]);
      var currentIds = getIdsFromQuery(query[param]);

      if (!isEqual(prevIds.sort(), currentIds.sort())) {
        getLabels(query[param], query).then(this.updateLabels);
      }
    }
  }, {
    key: "clearQuery",
    value: function clearQuery() {
      var _this$props2 = this.props,
          param = _this$props2.param,
          path = _this$props2.path,
          query = _this$props2.query;
      this.setState({
        selected: []
      });
      updateQueryString(_defineProperty({}, param, undefined), path, query);
    }
  }, {
    key: "updateLabels",
    value: function updateLabels(selected) {
      this.setState({
        selected: selected
      });
    }
  }, {
    key: "updateQuery",
    value: function updateQuery() {
      var _this$props3 = this.props,
          param = _this$props3.param,
          path = _this$props3.path,
          query = _this$props3.query;
      var selected = this.state.selected;
      var idList = selected.map(function (p) {
        return p.id;
      });
      updateQueryString(_defineProperty({}, param, idList.join(',')), path, query);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          labels = _this$props4.labels,
          type = _this$props4.type;
      var selected = this.state.selected;
      return createElement(Card, {
        title: labels.title,
        className: "woocommerce-filters__compare woocommerce-analytics__card"
      }, createElement("div", {
        className: "woocommerce-filters__compare-body"
      }, createElement(Search, {
        type: type,
        selected: selected,
        placeholder: labels.placeholder,
        onChange: function onChange(value) {
          _this2.setState({
            selected: value
          });
        }
      })), createElement("div", {
        className: "woocommerce-filters__compare-footer"
      }, createElement(CompareButton, {
        count: selected.length,
        helpText: labels.helpText,
        onClick: this.updateQuery
      }, labels.update), selected.length > 0 && createElement(Button, {
        isLink: true,
        onClick: this.clearQuery
      }, __('Clear all', 'woocommerce-admin'))));
    }
  }]);

  return CompareFilter;
}(Component);
CompareFilter.propTypes = {
  /**
   * Function used to fetch object labels via an API request, returns a Promise.
   */
  getLabels: PropTypes.func.isRequired,

  /**
   * Object of localized labels.
   */
  labels: PropTypes.shape({
    /**
     * Label for the search placeholder.
     */
    placeholder: PropTypes.string,

    /**
     * Label for the card title.
     */
    title: PropTypes.string,

    /**
     * Label for button which updates the URL/report.
     */
    update: PropTypes.string
  }),

  /**
   * The parameter to use in the querystring.
   */
  param: PropTypes.string.isRequired,

  /**
   * The `path` parameter supplied by React-Router
   */
  path: PropTypes.string.isRequired,

  /**
   * The query string represented in object form
   */
  query: PropTypes.object,

  /**
   * Which type of autocompleter should be used in the Search
   */
  type: PropTypes.string.isRequired
};
CompareFilter.defaultProps = {
  labels: {},
  query: {}
};
//# sourceMappingURL=index.js.map